"use client";

import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import { NavigationProgressProvider } from "@/components/layout/navigation-progress";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  if (typeof window === "undefined") {
    return makeQueryClient();
  }
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        themes={["light", "dark", "solarized"]}
        disableTransitionOnChange
      >
        <NavigationProgressProvider>{children}</NavigationProgressProvider>
        {/* duration: 5000 keeps toasts visible for ≥ 5 s (above the 4 s
            minimum required by the known-failure-pattern rule) so that
            Playwright can find them on Firefox under parallel test load,
            where the deferred-toast setTimeout may fire up to ~4 s after
            the server action resolves due to Firefox timer throttling. */}
        <Toaster toastOptions={{ duration: 5000 }} />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
